import _ from 'lodash';

function purifyText(v) {
    return (v || '').replace(/[\.\_\-\®+=!?@#$%^&*()'"\]\[\©]/g, ' ').replace(/\s\s+/g, ' ').trim().toLowerCase();
}

function replaceNumbersInText(text) {
    const numberStrings = [
        'zero', 'one', 'two', 'three', 'four', 'five',
        'six', 'seven', 'eight', 'nine', 'ten',
        'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen',
        'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'
    ];

    numberStrings.map((f, i) => text = (text || '').replace(new RegExp(f, 'g'), i));
    return text;
}

function findTextInArray(text, array, arrayTextSelector, skipElements) {
    skipElements = skipElements || ['and', 'or', 'with'];
    const purifiedText = replaceNumbersInText(purifyText(text));
    if (!purifiedText) return null;

    const splitted = purifiedText.split(' ').map(f => (f || '').trim()).filter(f => f);
    const checkEquality = (v) => {
        let eq = 0;
        eq += replaceNumbersInText(purifyText(v)).split(' ').filter(f => (f || '').trim()).filter(f => f && !skipElements.includes(f) && splitted.includes(f)).length;
        return eq;
    }
    const eqItems = array.map(f => ({ item: f, eq: checkEquality(arrayTextSelector(f)) })).filter(f => f.eq > 0);
    const result = _.orderBy(eqItems, ['eq'], ['desc'])[0];

    if (__DEBUG__)
        console.debug('findTextInArray', { text, array, eqItems, result, purifiedText });

    return result;
}

export default {
    findTextInArray,
    purifyText
}

export {
    findTextInArray,
    purifyText
}